<template>
  <b-modal
    :hide-footer="true"
    :title="$t('Cadastrar Animais de Estimação')"
    centered
    no-close-on-backdrop
    id="add-animais"
  >
    <form @submit.prevent="submit" ref="addItem">
      <div class="row">
        <form-select
          v-model="especie"
          grid="6"
          label="Espécie"
          :itens="$root.arrays.especies_animais"
          :required="true"
        />

        <form-input v-model="nome" grid="6" label="Nome do Animal" />

        <form-select
          v-model="sexo"
          grid="6"
          label="Sexo"
          :itens="$root.arrays.sexo_animal"
        />

        <form-select
          v-model="castrado"
          grid="6"
          label="Castrado(a)?"
          :itens="$root.arrays.pergunta"
        />
      </div>
      <div class="row pt-4 px-2 d-flex justify-content-end">
        <button
          type="submit"
          class="btn btn-success btn-add-animal"
          data-style="zoom-in"
        >
          <i class="mdi mdi-content-save"></i>
          Salvar
        </button>
      </div>
    </form>
  </b-modal>
</template>
<script>
export default {
  props: ["item"],
  data() {
    return {
      especie: "",
      sexo: "",
      nome: "",
      castrado: "",
    };
  },
  methods: {
    submit() {
      let ladda = Ladda.create(document.querySelector(".btn-add-animal"));
      ladda.start();
      axios
        .post("api/dashboard/familias/animal", {
          especie: this.especie,
          sexo: this.sexo,
          nome: this.nome,
          castrado: this.castrado,
          familia_id: this.item.id,
        })
        .then((response) => {
          this.$snack.success({
            button: false,
            text: "Animal cadastrado com sucesso.",
          });
          this.item.animais = response.data;
          this.$bvModal.hide("add-animais");

          this.especie = "";
          this.sexo = "";
          this.nome = "";
          this.castrado = "";
          ladda.stop();
        })
        .catch(() => ladda.stop());
    },
  },
};
</script>
